import * as React from 'react'

import FormLabel from '@mui/material/FormLabel'
import Box from '@mui/material/Box'

import { ReferralTypeSelect } from './fields/ReferralSource/ReferralTypeSelect'
import { TidalContent } from './content'
import { ReferralFormProps } from '@user/components/Referrals/components/UpdateReferral/UpdateReferralForm/UpdateReferralForm'

export default function TidalUpdateReferralForm(props: ReferralFormProps) {
  return (
    <Box>
      <FormLabel sx={{ fontWeight: 500, mb: 0 }}>
        Select referral type*
      </FormLabel>
      <Box ml={2} mb={'12px'}>
        <ReferralTypeSelect {...props} />
      </Box>
      <TidalContent {...props} />
    </Box>
  )
}
